const LeaCodes = {
  'S': 'School',
  'SC': 'School Charter',
  'SD': 'School level - School ADE',
  'SS': 'School Correctional Services'
}

export { LeaCodes }